module.exports = __webpack_public_path__ + "9488d02b/img/scraper-icon.df6ccde5.svg";